<!-- Enhanced PropertyStatusModals.vue -->
<template>
  <div>
    <!-- Enhanced Property Suspension Modal -->
    <div class="modal fade property-suspension-modal" tabindex="-1" role="dialog" aria-labelledby="mySuspensionModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-danger text-white">
            <h5 class="modal-title text-uppercase text-white" id="mySuspensionModalLabel">
              <i class="mdi mdi-lock me-2"></i>Suspend Property
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-warning">
                  <p><i class="mdi mdi-alert-outline me-2"></i> You are about to suspend property <strong>{{ property.LRNumber }}</strong>.</p>
                  <p>This action will prevent all transactions until the property is reinstated.</p>
                </div>
              </div>

              <!-- Suspension Details Form -->
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="suspensionReason" class="form-label">Suspension Reason *</label>
                  <textarea v-model="suspensionForm.reason" class="form-control" id="suspensionReason" rows="3"
                            placeholder="Provide detailed reason for suspension" required></textarea>
                </div>

                <div class="form-group mb-3">
                  <label for="suspensionStartDate" class="form-label">Start Date *</label>
                  <input v-model="suspensionForm.startDate" type="date" class="form-control" id="suspensionStartDate" required>
                </div>

                <div class="form-group mb-3">
                  <label for="suspensionEndDate" class="form-label">End Date</label>
                  <input v-model="suspensionForm.endDate" type="date" class="form-control" id="suspensionEndDate">
                  <small class="text-muted">Leave empty for indefinite suspension</small>
                </div>
              </div>

              <!-- Document Upload and Notifications -->
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="suspensionDocuments" class="form-label">Supporting Documents</label>
                  <input @change="handleSuspensionDocuments" type="file" class="form-control" id="suspensionDocuments"
                         multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                  <small class="text-muted">Upload court orders, notices, or other supporting documents</small>
                  <div v-if="suspensionForm.documents.length > 0" class="mt-2">
                    <div class="badge bg-info me-1" v-for="(doc, index) in suspensionForm.documents" :key="index">
                      {{ doc.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <div class="form-check">
                    <input v-model="suspensionForm.notifyOwner" class="form-check-input" type="checkbox"
                           id="notifyOwnerSuspension" checked>
                    <label class="form-check-label" for="notifyOwnerSuspension">
                      Notify property owner via SMS and Email
                    </label>
                  </div>
                </div>

                <div class="alert alert-info">
                  <h6><i class="mdi mdi-information me-2"></i>Owner will be notified about:</h6>
                  <ul class="mb-0 small">
                    <li>Suspension reason and duration</li>
                    <li>Impact on property transactions</li>
                    <li>Contact information for appeals</li>
                    <li>Continued accrual of rates and penalties</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="handleSuspend" type="button" class="btn btn-danger">
              <i class="mdi mdi-lock me-1"></i> Suspend Property
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Property Reinstatement Modal -->
    <div class="modal fade property-reinstatement-modal" tabindex="-1" role="dialog" aria-labelledby="myReinstatementModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-success text-white">
            <h5 class="modal-title text-uppercase text-white" id="myReinstatementModalLabel">
              <i class="mdi mdi-lock-open-outline me-2"></i>Reinstate Property
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-info">
                  <p><i class="mdi mdi-information-outline me-2"></i> You are about to reinstate property <strong>{{ property.LRNumber }}</strong>.</p>
                  <p>This will restore normal property operations and transaction capabilities.</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="reinstatementReason" class="form-label">Reinstatement Reason *</label>
                  <textarea v-model="reinstatementForm.reason" class="form-control" id="reinstatementReason" rows="3"
                            placeholder="Provide reason for reinstatement" required></textarea>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="reinstatementDocuments" class="form-label">Supporting Documents</label>
                  <input @change="handleReinstatementDocuments" type="file" class="form-control" id="reinstatementDocuments"
                         multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                  <small class="text-muted">Upload clearance letters, approvals, or other documents</small>
                  <div v-if="reinstatementForm.documents.length > 0" class="mt-2">
                    <div class="badge bg-info me-1" v-for="(doc, index) in reinstatementForm.documents" :key="index">
                      {{ doc.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <div class="form-check">
                    <input v-model="reinstatementForm.notifyOwner" class="form-check-input" type="checkbox"
                           id="notifyOwnerReinstatement" checked>
                    <label class="form-check-label" for="notifyOwnerReinstatement">
                      Notify property owner via SMS and Email
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="handleReinstate" type="button" class="btn btn-success">
              <i class="mdi mdi-lock-open-outline me-1"></i> Reinstate Property
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Rate Struck Modal -->
    <div class="modal fade rate-struck-modal" tabindex="-1" role="dialog" aria-labelledby="rateStruckModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-warning text-dark">
            <h5 class="modal-title text-uppercase" id="rateStruckModalLabel">
              <i class="mdi mdi-currency-usd-off me-2"></i>Mark Property as Rate Struck
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-warning">
                  <p><i class="mdi mdi-alert-outline me-2"></i> You are about to mark property <strong>{{ property.LRNumber }}</strong> as Rate Struck.</p>
                  <p>This property will be exempt from land rates during the specified period.</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="rateStruckReason" class="form-label">Rate Struck Reason *</label>
                  <textarea v-model="rateStruckForm.reason" class="form-control" id="rateStruckReason" rows="3"
                            placeholder="Court order, exemption, dispute resolution, etc." required></textarea>
                </div>

                <div class="form-group mb-3">
                  <label for="rateStruckStartDate" class="form-label">Start Date *</label>
                  <input v-model="rateStruckForm.startDate" type="date" class="form-control" id="rateStruckStartDate" required>
                </div>

                <div class="form-group mb-3">
                  <label for="rateStruckEndDate" class="form-label">End Date</label>
                  <input v-model="rateStruckForm.endDate" type="date" class="form-control" id="rateStruckEndDate">
                  <small class="text-muted">Leave empty for indefinite exemption</small>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="rateStruckDocuments" class="form-label">Supporting Documents</label>
                  <input @change="handleRateStruckDocuments" type="file" class="form-control" id="rateStruckDocuments"
                         multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                  <small class="text-muted">Upload court orders, exemption letters, etc.</small>
                  <div v-if="rateStruckForm.documents.length > 0" class="mt-2">
                    <div class="badge bg-info me-1" v-for="(doc, index) in rateStruckForm.documents" :key="index">
                      {{ doc.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <div class="form-check">
                    <input v-model="rateStruckForm.notifyOwner" class="form-check-input" type="checkbox"
                           id="notifyOwnerRateStruck" checked>
                    <label class="form-check-label" for="notifyOwnerRateStruck">
                      Notify property owner via SMS and Email
                    </label>
                  </div>
                </div>

                <div class="alert alert-warning">
                  <h6><i class="mdi mdi-information me-2"></i>Rate Struck Impact:</h6>
                  <ul class="mb-0 small">
                    <li>No new land rate charges during exemption</li>
                    <li>Existing arrears and penalties remain</li>
                    <li>Ground rent charges continue (if applicable)</li>
                    <li>Property transactions may continue</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="handleRateStruck" type="button" class="btn btn-warning">
              <i class="mdi mdi-currency-usd-off me-1"></i> Mark as Rate Struck
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Remove Rate Struck Modal -->
    <div class="modal fade remove-rate-struck-modal" tabindex="-1" role="dialog" aria-labelledby="removeRateStruckModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-info text-white">
            <h5 class="modal-title text-uppercase text-white" id="removeRateStruckModalLabel">
              <i class="mdi mdi-currency-usd me-2"></i>Remove Rate Struck Status
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-info">
                  <p><i class="mdi mdi-information-outline me-2"></i> You are about to remove Rate Struck status for property <strong>{{ property.LRNumber }}</strong>.</p>
                  <p>Normal land rate collection will resume immediately.</p>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="removeRateStruckReason" class="form-label">Removal Reason *</label>
                  <textarea v-model="removeRateStruckForm.reason" class="form-control" id="removeRateStruckReason" rows="3"
                            placeholder="Resolution completed, court order lifted, etc." required></textarea>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label for="removeRateStruckDocuments" class="form-label">Supporting Documents</label>
                  <input @change="handleRemoveRateStruckDocuments" type="file" class="form-control" id="removeRateStruckDocuments"
                         multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png">
                  <small class="text-muted">Upload resolution documents, court orders, etc.</small>
                  <div v-if="removeRateStruckForm.documents.length > 0" class="mt-2">
                    <div class="badge bg-info me-1" v-for="(doc, index) in removeRateStruckForm.documents" :key="index">
                      {{ doc.name }}
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <div class="form-check">
                    <input v-model="removeRateStruckForm.notifyOwner" class="form-check-input" type="checkbox"
                           id="notifyOwnerRemoveRateStruck" checked>
                    <label class="form-check-label" for="notifyOwnerRemoveRateStruck">
                      Notify property owner via SMS and Email
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button @click="handleRemoveRateStruck" type="button" class="btn btn-info">
              <i class="mdi mdi-currency-usd me-1"></i> Remove Rate Struck Status
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Property Status History Modal -->
    <div class="modal fade property-status-history-modal" tabindex="-1" role="dialog" aria-labelledby="statusHistoryModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title text-uppercase text-white" id="statusHistoryModalLabel">
              <i class="mdi mdi-history me-2"></i>Property Status History - {{ property.LRNumber }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="statusHistory.length > 0" class="table-responsive">
              <table class="table table-striped">
                <thead class="table-dark">
                <tr>
                  <th>Action</th>
                  <th>Date</th>
                  <th>Reason</th>
                  <th>Period</th>
                  <th>Action By</th>
                  <th>Status</th>
                  <th>Documents</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in statusHistory" :key="item.id">
                  <td>
                      <span class="badge" :class="getActionBadgeClass(item.action_type)">
                        {{ item.action_type }}
                      </span>
                  </td>
                  <td>{{ formatDate(item.created_date) }}</td>
                  <td class="small">{{ item.reason }}</td>
                  <td>
                    <div v-if="item.start_date">
                      <small>{{ formatDate(item.start_date) }}</small>
                      <span v-if="item.end_date"> to {{ formatDate(item.end_date) }}</span>
                      <span v-else class="text-muted"> (Indefinite)</span>
                    </div>
                  </td>
                  <td class="small">{{ item.action_by }}</td>
                  <td>
                      <span class="badge" :class="getStatusBadgeClass(item.status)">
                        {{ item.status }}
                      </span>
                  </td>
                  <td>
                      <span v-if="item.documents && item.documents.length > 0" class="badge bg-info">
                        {{ item.documents.length }} files
                      </span>
                    <span v-else class="text-muted">None</span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center py-4">
              <i class="mdi mdi-history text-muted" style="font-size: 48px;"></i>
              <h5 class="text-muted mt-3">No Status History</h5>
              <p class="text-muted">This property has no recorded status changes.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnhancedPropertyStatusModals',
  props: {
    property: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['suspend-property', 'reinstate-property', 'set-rate-struck', 'remove-rate-struck'],
  data() {
    return {
      suspensionForm: {
        reason: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        documents: [],
        notifyOwner: true
      },
      reinstatementForm: {
        reason: '',
        documents: [],
        notifyOwner: true
      },
      rateStruckForm: {
        reason: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        documents: [],
        notifyOwner: true
      },
      removeRateStruckForm: {
        reason: '',
        documents: [],
        notifyOwner: true
      },
      statusHistory: []
    }
  },
  methods: {
    handleSuspensionDocuments(event) {
      this.suspensionForm.documents = Array.from(event.target.files);
    },

    handleReinstatementDocuments(event) {
      this.reinstatementForm.documents = Array.from(event.target.files);
    },

    handleRateStruckDocuments(event) {
      this.rateStruckForm.documents = Array.from(event.target.files);
    },

    handleRemoveRateStruckDocuments(event) {
      this.removeRateStruckForm.documents = Array.from(event.target.files);
    },

    handleSuspend() {
      if (!this.suspensionForm.reason.trim()) {
        alert('Please provide a reason for suspension');
        return;
      }

      if (!this.suspensionForm.startDate) {
        alert('Please select a start date');
        return;
      }

      const formData = new FormData();
      formData.append('propertyID', this.property.id);
      formData.append('LRNumber', this.property.LRNumber);
      formData.append('reason', this.suspensionForm.reason);
      formData.append('startDate', this.suspensionForm.startDate);
      formData.append('endDate', this.suspensionForm.endDate || '');
      formData.append('notifyOwner', this.suspensionForm.notifyOwner ? 'yes' : 'no');
      formData.append('sessionNames', sessionStorage.getItem('sessionNames'));
      formData.append('sessionIdNo', sessionStorage.getItem('sessionIdNo'));

      // Append documents
      this.suspensionForm.documents.forEach((file, index) => {
        formData.append(`suspensionDocuments[${index}]`, file);
      });

      this.$emit('suspend-property', formData);
      this.resetSuspensionForm();
    },

    handleReinstate() {
      if (!this.reinstatementForm.reason.trim()) {
        alert('Please provide a reason for reinstatement');
        return;
      }

      const formData = new FormData();
      formData.append('propertyID', this.property.id);
      formData.append('LRNumber', this.property.LRNumber);
      formData.append('reason', this.reinstatementForm.reason);
      formData.append('notifyOwner', this.reinstatementForm.notifyOwner ? 'yes' : 'no');
      formData.append('sessionNames', sessionStorage.getItem('sessionNames'));
      formData.append('sessionIdNo', sessionStorage.getItem('sessionIdNo'));

      // Append documents
      this.reinstatementForm.documents.forEach((file, index) => {
        formData.append(`reinstatementDocuments[${index}]`, file);
      });

      this.$emit('reinstate-property', formData);
      this.resetReinstatementForm();
    },

    handleRateStruck() {
      if (!this.rateStruckForm.reason.trim()) {
        alert('Please provide a reason for marking as rate struck');
        return;
      }

      if (!this.rateStruckForm.startDate) {
        alert('Please select a start date');
        return;
      }

      const formData = new FormData();
      formData.append('propertyID', this.property.id);
      formData.append('LRNumber', this.property.LRNumber);
      formData.append('reason', this.rateStruckForm.reason);
      formData.append('startDate', this.rateStruckForm.startDate);
      formData.append('endDate', this.rateStruckForm.endDate || '');
      formData.append('notifyOwner', this.rateStruckForm.notifyOwner ? 'yes' : 'no');
      formData.append('sessionNames', sessionStorage.getItem('sessionNames'));
      formData.append('sessionIdNo', sessionStorage.getItem('sessionIdNo'));

      // Append documents
      this.rateStruckForm.documents.forEach((file, index) => {
        formData.append(`rateStruckDocuments[${index}]`, file);
      });

      this.$emit('set-rate-struck', formData);
      this.resetRateStruckForm();
    },

    handleRemoveRateStruck() {
      if (!this.removeRateStruckForm.reason.trim()) {
        alert('Please provide a reason for removing rate struck status');
        return;
      }

      const formData = new FormData();
      formData.append('propertyID', this.property.id);
      formData.append('LRNumber', this.property.LRNumber);
      formData.append('reason', this.removeRateStruckForm.reason);
      formData.append('notifyOwner', this.removeRateStruckForm.notifyOwner ? 'yes' : 'no');
      formData.append('sessionNames', sessionStorage.getItem('sessionNames'));
      formData.append('sessionIdNo', sessionStorage.getItem('sessionIdNo'));

      // Append documents
      this.removeRateStruckForm.documents.forEach((file, index) => {
        formData.append(`removeRateStruckDocuments[${index}]`, file);
      });

      this.$emit('remove-rate-struck', formData);
      this.resetRemoveRateStruckForm();
    },

    resetSuspensionForm() {
      this.suspensionForm = {
        reason: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        documents: [],
        notifyOwner: true
      };
    },

    resetReinstatementForm() {
      this.reinstatementForm = {
        reason: '',
        documents: [],
        notifyOwner: true
      };
    },

    resetRateStruckForm() {
      this.rateStruckForm = {
        reason: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        documents: [],
        notifyOwner: true
      };
    },

    resetRemoveRateStruckForm() {
      this.removeRateStruckForm = {
        reason: '',
        documents: [],
        notifyOwner: true
      };
    },

    formatDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString('en-GB');
    },

    getActionBadgeClass(actionType) {
      const classes = {
        'Suspension': 'bg-danger',
        'Reinstatement': 'bg-success',
        'Rate Struck': 'bg-warning'
      };
      return classes[actionType] || 'bg-secondary';
    },

    getStatusBadgeClass(status) {
      const classes = {
        'active': 'bg-success',
        'reinstated': 'bg-info',
        'removed': 'bg-secondary',
        'completed': 'bg-primary'
      };
      return classes[status] || 'bg-secondary';
    }
  }
}
</script>

<style scoped>
.modal-lg {
  max-width: 900px;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.badge {
  font-size: 0.75em;
}

.table th {
  font-size: 0.85rem;
  font-weight: 600;
}

.table td {
  font-size: 0.85rem;
  vertical-align: middle;
}

.alert {
  border-radius: 8px;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>